<template>
  <div class="privacy-policy-container">
    <app-header />
    <div class="area-article">
      <h1 class="area-title">
        {{ title }}
      </h1>
      <div class="area-content v1-content" v-html="$md.render(body)" />
    </div>
    <app-footer />
  </div>
</template>

<script>
/* eslint-disable */
import AppHeader from '../organisms/AppHeader'
import AppFooter from '../organisms/AppFooter'

export default {
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    title() {
      return 'プライバシーポリシー'
    },
    body() {
      return `
株式会社ALIS（以下「当社」といいます）は、利用者よりお預かりした個人情報の保護に努めることを社会的責務として、今後も信頼いただける企業を目指すため、個人情報のお取り扱いに関する方針を定め、大切な個人情報の適正な管理と利用、保護に努めます。
当社の提供するサービス「ALIS」（以下「本サービス」といいます）における、利用者についての個人情報を含む利用者情報の取扱いについて、以下のとおり当社の個人情報保護方針に基づき本サービスのプライバシーポリシー（以下「本ポリシー」といいます）を定めます。なお、本ポリシーで定義されていない用語については、「ALIS利用規約」で定める用語の定義に従うものとします。

## 1. 個人情報の定義

本ポリシーにおいて、個人情報とは、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）、または個人識別符号が含まれるものを指します。

・非個人情報

非個人情報とは、ブラウザの種類、IPアドレス、当サイトに移動される前に訪れたウェブサイトのURLなど、利用者個人を特定できない情報です。当社は、利用者が本サービスをご利用になる際に一定の非個人情報を自動的に収集することがあります。

・Cookie（クッキー）

当社は、利用者によりよいサービスを提供するため、Cookie （クッキー）を使用することがありますが、これにより個人を特定できる情報の収集を行うものではございません。また、Cookieの受け入れを希望されない場合は、ブラウザの設定で変更することができます。ただし、Cookieを無効化すると、本サービスの一部の機能をご利用いただけなくなる場合があります。

・ログ

利用者が本サービス利用時に自動で生成され、IPアドレス、ブラウザ種類、ブラウザ言語などが保存されます。これらの情報は利用者環境を分析し、より良いサービス提供のため、また正常なサービス提供を妨害する不正行為防止のために利用いたします。

## 2. 個人情報の利用目的

当社は本サービス内で会員登録やお問合せ受付等におきまして、上記で定義されます個人情報を取得いたします。

当社は、あらかじめ利用者の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取扱うことはありません。
当社では、個人情報の利用に際しては、本ポリシー内または各サービスのウェブサイト内において、あらかじめ利用目的をできる限り特定した上で公表し、収集します。
また、当社は、利用者の個人情報を、以下の目的で利用いたします。

(1)    利用者が本サービスを円滑に利用できるようにするため
(2)    本サービスの不正利用防止のため
(3)    本サービスに関する情報等または当社以外の事業者が広告主となる広告情報等をメールマガジン等により告知するため
(4)    当社および第三者の商品等の広告または宣伝（ダイレクトメールの送付、電子メールの送信、リマーケティング、リターゲティング広告を含む。）のため
(5)    利用者の本人認証のため
(6)    利用者からのお問い合わせに対する対応のため
(7)    マーケティングデータの調査、統計、分析のため
(8)    本サービス利用に関する統計データを作成するため
(9)    本サービスの企画立案検討、サービス改善にあたってのアンケート実施および分析のため
(10)  当社が運営する別サービスの企画立案、開発、運営のため
(11)  イベント等の運営管理のため
(12)  キャンペーン等の抽選および賞品や商品発送のため
(13)  利用者に関する情報を本サービス内で紹介するため
(14)  その他本サービスに関する重要なお知らせなど、必要に応じた連絡を行うため
なお、当社が本サービス内で取得いたします個人情報は、他の情報源から得た情報で補足することがございます。

## 3. 個人情報利用目的の変更

当社は、個人情報の利用目的を、変更前の利用目的と関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には利用者に通知または公表します。

## 4. 個人情報の利用制限

当社は、原則として、利用者本人の同意を得ずに、あらかじめ特定し公表した利用目的の達成に必要な範囲を超えて利用者の個人情報を取り扱うことはいたしません。ただし、以下の各号に該当する場合は、 予め特定し公表した利用目的の達成に必要な範囲を超えて利用者の個人情報を取り扱うことがあります。

(1)    法令に基づく場合
(2)    人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
(3)    公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
(4)    国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき

## 5. 個人情報の安全管理

当社では、個人情報を取り扱う際に、個人情報の保護に関する法律その他個人情報保護に関する諸法令に関し、個人情報保護委員会および所管官庁が公表するガイドライン類に定められた義務、ならびに本ポリシーを遵守します。 また、当社では、利用者よりお預かりした個人情報は、組織的、物理的、人的、技術的施策を講じることで個人情報への不正な侵入、個人情報の紛失、破壊、改ざん、および漏えい等を防止いたします。

## 6. 個人情報の第三者への提供

当社は、原則として、利用者よりお預かりした個人情報を、利用者本人の同意を得ずに第三者に提供することはいたしません。ただし、以下の場合は関係法令に反しない範囲で、利用者本人の同意なく利用者の個人情報を提供することがあります。

(1)    法令に基づく場合
(2)    人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
(3)    公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
(4)    国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき

ただし次に掲げる場合は上記に定める第三者には該当しません。
(1)    当社が利用目的の達成に必要な範囲内において個人情報の取り扱いの全部または一部を委託することに伴って当該個人情報が提供される場合
(2)    合併その他の事由による事業の承継に伴って個人情報が提供される場合

## 7. 第三者によるCookie、Webビーコン等の使用について

本サービスにおいて、効果的な広告配信や、利用状況測定等のためにも、第三者による、Webビーコンその他の類似技術を利用することがあります。これらの技術は、当社による当社サービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookie等を無効化されたいユーザーは、ウェブブラウザの設定を変更することにより Cookie等を無効化することができます。但し、Cookie等を無効化すると、当社サービスの一部の機能をご利用いただけなくなる場合があります。

## 8. プライバシーポリシーの改定

当社は、収集する個人情報の変更、利用目的の変更、またはその他プライバシーポリシーの変更を行う際は、本ページへの変更をもって公表とさせていただきます。変更後のプライバシーポリシーはサイト上に改定日を表示した時点より効力を生じます。ただし、法令上会員の同意が必要となる内容の変更の場合は、当社所定の方法で会員の同意を得るものとします。

## 9. お問い合わせ窓口

開示等のお申し出、ご意見、ご質問、苦情のお申し出その他個人情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。

東京都渋谷区神南1-20-7 川原ビル6F
株式会社ALIS　　お問い合わせ窓口
E-mail：info@alismedia.jp

株式会社ALIS
代表取締役社長　安昌浩

2018年 4月 17日 制定・施行
`
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-policy-container {
  display: grid;
  grid-template-rows: 100px 50px 1fr 75px;
  grid-template-columns: 1fr 640px 1fr;
  /* prettier-ignore */
  grid-template-areas:
    'app-header       app-header       app-header      '
    '...              ...              ...             '
    '...              article          ...             '
    'app-footer       app-footer       app-footer      ';
  background: white;
}

.area-article {
  display: grid;
  grid-area: article;
  grid-template-rows: auto;
  grid-template-columns: auto;
  grid-gap: 30px;
  /* prettier-ignore */
  grid-template-areas:
    'title  '
    'content';
}

.area-title {
  font-size: 25px;
  grid-area: title;
  letter-spacing: 0.05em;
}

.area-content {
  grid-area: content;
}

@media screen and (max-width: 1080px) {
  .privacy-policy-container {
    grid-template-rows: 100px 50px 1fr 75px;
  }
}

@media screen and (max-width: 820px) {
  .privacy-policy-container {
    grid-template-columns: 80px 1fr 80px;
  }
}

@media screen and (max-width: 550px) {
  .privacy-policy-container {
    grid-template-rows: 70px 0 1fr min-content;
    grid-template-columns: 10px 1fr 10px;
    /* prettier-ignore */
    grid-template-areas:
    'app-header       app-header       app-header      '
    '...              ...              ...             '
    'article          article          article         '
    'app-footer       app-footer       app-footer      ';
  }

  .area-article {
    grid-template-columns: 8px auto 8px;
    grid-gap: 10px;
    /* prettier-ignore */
    grid-template-areas:
      '...            title             ...           '
      '...            content           ...           ';
  }

  .area-content {
    width: 90vw;
  }

  .area-title {
    font-size: 18px;
    grid-area: title;
    letter-spacing: 0.1em;
  }
}
</style>
